<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title inline">Caveat Property Type Mapping</h3>
    </div>
    <div class="card-body">
      <form @submit.prevent="onSubmit">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="form-label">Caveat Property Type</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="form.caveat_property"
                  required
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label class="form-label">Property Type</label>
              <div class="input-group">
                <select
                  class="form-control custom-select"
                  v-model="form.property_type"
                  required
                >
                  <option value>-Select-</option>
                  <option
                    v-for="(value, key, index) in propertyTypes"
                    :key="index"
                    :value="value"
                  >
                    {{ value.config.value }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="form-label">&nbsp;</label>
              <button type="submit" class="btn btn-primary">Add Mapping</button>
            </div>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-md-6">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Caveat Property Type</th>
                  <th scope="col">Property Type</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key, index) in caveat" :key="index">
                  <td>{{ value.config.caveat_property.value }}</td>
                  <td>{{ value.config.property_type.config.value }}</td>
                  <td>
                    <button
                      type="button"
                      v-b-modal="'edit-modal'"
                      title="Edit"
                      class="btn btn-icon btn-border"
                      @click="setCaveatProperty(value, key, index)"
                    >
                      <!-- v-b-modal="'edit-modal'" -->
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                    <button
                      type="button"
                      title="Delete"
                      class="btn btn-icon btn-border"
                      @click="deleteCaveatProperty(value, key, index)"
                    >
                      <!-- v-b-modal="'edit-modal'" -->
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="caveat.length == 0">
                  <td colspan="3" class="text-center">No records found!</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Modal -->
    <b-modal
      id="edit-modal"
      size="lg"
      title="Edit Caveat Tenure Type Mapping"
      hide-footer
      ref="editModal"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop
    >
      <form @submit.prevent="updateCaveatProperty">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Caveat Property Type</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="cvt.config.caveat_property.value"
                  required
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label">Property Type</label>
              <div class="input-group">
                <select
                  class="form-control custom-select"
                  v-model="cvt.config.property_type"
                  required
                >
                  <option value>-Select-</option>
                  <option
                    v-for="(value, key, index) in propertyTypes"
                    :key="index"
                    :value="value"
                  >
                    {{ value.config.value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary pull-right">
              Update
            </button>
            <button
              type="button"
              class="btn btn-secondary pull-right"
              style="margin-right: 5px"
              @click="closeModal"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */
import Swal from "sweetalert2";
export default {
  data() {
    return {
      propertyTypes: {},
      form: {
        caveat_property: "",
        property_type: "",
      },
      caveat_property: {},
      caveat: {},
      cvt: {
        config: {
          caveat_property: { value: "" },
          property_type: { config: { value: "" } },
        },
      },
    };
  },
  methods: {
    deleteCaveatProperty(value, key, index) {
      let config_id = value.id;
      let property_id = value.config.property_type.id;
      let config = value.config.property_type.config;
      config.isMapped = false;

      Swal({
        title: "Are you sure to delete?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.value) {
          this.$http
            .post(this.rootUrl + "delete-property-mapping", {
              property_type_id: property_id,
              id: config_id,
              property_type: config,
            })
            .then(
              (res) => {
                this.refreshToken(res);
                this.caveat = res.data || {
                  config: [],
                };
              },
              (err) => {
                this.$snotify.error(err.response.data.message, "Valuation", {
                  timeout: 4000,
                  showProgressBar: false,
                  position: "rightTop",
                });
              }
            );
        }
      });
    },
    closeModal() {
      // Swal({
      //   title: "Are you sure to cancel and discard changes?",
      //   type: "warning",
      //   showCancelButton: true,
      //   confirmButtonText: "Yes",
      //   cancelButtonText: "Cancel"
      // }).then(result => {
      //   if (result.value) {
      this.$refs.editModal.hide();
      //   }
      // });
    },

    loadData() {
      //this.$parent.$refs.progressModal.show();
      this.$http
        .get(this.rootUrl + "config/property-type", this.corsConfig)
        .then(
          (res) => {
            this.refreshToken(res);
            this.propertyTypes = res.data;
            //this.$parent.$refs.progressModal.hide();
          },
          (err) => {
            //this.$parent.$refs.progressModal.hide();
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
          }
        );
      //this.$parent.$refs.progressModal.show();
      this.$http
        .get(this.rootUrl + "config/caveat-property", this.corsConfig)
        .then(
          (res) => {
            this.refreshToken(res);
            this.caveat = res.data || {
              config: [],
            };
            //this.$parent.$refs.progressModal.hide();
          },
          (err) => {
            //this.$parent.$refs.progressModal.hide();
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
          }
        );
    },
    updateCaveatProperty() {
      // this.$parent.$refs.progressModal.show();
      this.cvt.config.property_type.config.isMapped = true;

      this.$http
        .put(this.rootUrl + "config/caveat-property/" + this.cvt.id, {
          caveat: this.cvt.config,
          property_type: this.cvt.config.property_type.config,
          property_type_id: this.cvt.config.property_type.id,
        })
        .then(
          (res) => {
            this.refreshToken(res);
            this.$refs.editModal.hide();
            this.caveat = res.data;
            // this.$parent.$refs.progressModal.hide();
          },
          (err) => {
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
          }
        );
    },
    setCaveatProperty(value, key, index) {
      this.cvt = value;
    },
    onSubmit() {
      //this.$parent.$refs.progressModal.show();
      this.form.property_type.config.isMapped = true;
      const obj = {
        property_type: this.form.property_type,
        caveat_property: {
          key: this.toDash(this.form.caveat_property),
          value: this.form.caveat_property,
        },
      };
      this.$http
        .post(this.rootUrl + "config/caveat-property", {
          caveat: obj,
          property_type: this.form.property_type.config,
          property_type_id: this.form.property_type.id,
        })
        .then(
          (res) => {
            this.refreshToken(res);
            this.resetForm();
            this.caveat = res.data;
            //this.$parent.$refs.progressModal.hide();
          },
          (err) => {
            //this.$parent.$refs.progressModal.hide();
            this.$snotify.error(err.response.data.message, "Valuation", {
              timeout: 4000,
              showProgressBar: false,
              position: "rightTop",
            });
          }
        );
    },
    resetForm() {
      this.form = {
        caveat_property: "",
        property_type: "",
      };
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
